module.exports = __webpack_public_path__ + "img/pressure.4692a1f6.svg";